var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3177 8.96746C35.8472 9.49698 35.8472 10.3555 35.3177 10.885L16.4144 29.7883C15.7784 30.4243 14.7473 30.4243 14.1113 29.7883L6.11199 21.789C5.58246 21.2595 5.58246 20.4009 6.11199 19.8714C6.64152 19.3419 7.50005 19.3419 8.02957 19.8714L15.2629 27.1047L33.4001 8.96746C33.9296 8.43793 34.7882 8.43793 35.3177 8.96746Z",
    fill: "#5B8E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckDesktop);
export default __webpack_public_path__ + "static/media/success-check-desktop.ef89f8c8870e3ae84de1a78280bb3970.svg";
export { ForwardRef as ReactComponent };